<p-table  #miSurvey [value]="pondTableDataWithFilter" [rows]="10" [paginator]="true" [globalFilterFields]="[
'appid',
'District',
'Block',
'Village',
'nextuser',
'NextAction',
'assigneddate',
'Level_ID',
'ActionType',
'Status',
'nextuser',
'NextAction'
]" responsiveLayout="scroll" [rowHover]="true" dataKey="appid"
currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
[showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines" [tableStyle]="{'max-width': '80rem'}">
<ng-template pTemplate="caption">
    <div class="grid d-flex align-items-center justify-content-end" style="background-color: #ff0000;">
        <!-- Left side -->
        <div class="col-7">
            <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'white'}">{{ tableHeaderName | translate}}</h5>
        </div>
        <!-- Middle section for buttons -->
        <!-- <div class="col-12 md:col-4 d-flex justify-content-center"> -->
            <!-- <label class="pr-2">{{ 'User Filter' }}</label>
            <p-dropdown [options]="miUnderProcFilterList" appendTo="body" (onChange)="onSelectMIConsFilter()" [(ngModel)]="selectedMIUnderProcFilter"
                placeholder="{{'ALL'| translate}}" optionLabel="actionLevel" [showClear]="true"></p-dropdown> -->
        <!-- </div> -->
        <!-- Right side for search -->
        <div class="col-12 md:col-5 gap-3 d-flex align-items-center justify-content-end">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')" placeholder="{{'SEARCH'| translate}}" />
            </span>
            <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download" class="p-button-help mx-1"></button>
            <p-menu #menu [popup]="true" [model]="pondRejectReport"></p-menu>
        </div>
    </div>
</ng-template>

<ng-template pTemplate="header">
    <tr>
        <th>{{'S_NO'| translate}}
            <!-- <p-columnFilter type="text" field="Row_No" display="menu"></p-columnFilter>
        <p-sortIcon field="Row_No"></p-sortIcon> -->
        </th>
        <th pSortableColumn="appid">{{'APP_ID'| translate}}</th>
        <th pSortableColumn="District">{{'DISTRICT'| translate}}</th>
        <th pSortableColumn="Block">{{'BLOCK'| translate}}</th>
        <th pSortableColumn="Village">{{'VILLAGE'| translate}}</th>
        <th pSortableColumn="Level_ID">{{'CURRENT_LEVEL'| translate}}</th>
        <th pSortableColumn="ActionType">{{'CURRENT_ACTION'| translate}}</th>
        <th pSortableColumn="assigneddate">{{'LAST_ACTION_DATE'| translate}}</th>
        <th pSortableColumn="Status">{{'STATUS'| translate}}</th>
        <th pSortableColumn="nextuser">{{'PENDING_LEVEL'| translate}}</th>
        <th pSortableColumn="NextAction">{{'PENDING_ACTION'| translate}}</th>
        <th>{{'VIEW' | translate}}</th>
    </tr>
</ng-template>

<ng-template pTemplate="body" let-consolidateData let-ri="rowIndex">
    <tr class="body-section">
        <td>{{ ri + 1 }}</td>
        <td>{{consolidateData?.appid}}</td>
        <td>{{consolidateData?.District}}</td>
        <td>{{consolidateData?.Block}}</td>
        <td>{{consolidateData?.Village}}</td>
        <td>{{consolidateData?.Level_ID}}</td>
        <td>{{consolidateData?.ActionType}}</td>
        <td>{{consolidateData?.assigneddate | date: "mediumDate"}}</td>
        <td>{{consolidateData?.Status}}</td>
        <td>{{consolidateData?.nextuser}}</td>
        <td>{{consolidateData?.NextAction}}</td>
        <td>
            <button pButton pRipple pTooltip="view application" icon="pi pi-eye"
                class="p-button-rounded p-button-accent p-button-primary p-button-sm"
                (click)="printForm(consolidateData.appid)"></button>
        </td>
    </tr>
</ng-template>

<ng-template pTemplate="footer">
    
</ng-template>

</p-table>